module.exports = __webpack_public_path__ + "static/media/Social_Icons-01.a4533609.svg";